export class InvoiceDetailModel {
  public ivd_key: string = undefined;
  public ivd_mbr_key: string = undefined;
  public ivd_pak_prd_key: string = undefined;
  public ptp_code: 'Kit' | 'Membership Dues' | 'Subscription' | string = undefined;
  public prd_key: string = undefined;
  public prd_atc_key: string = undefined;
  public prd_code: string = undefined;
  public prc_key: string = undefined;
  public prc_code: string = undefined;
  public prc_display_name: string = undefined;
  public ivd_price: number = undefined;
  public ivd_discountamount: number = undefined;
  public ivd_total: number = undefined;
  public ivd_balance: number = undefined;
  public ivd_netpayment: number = undefined;
  public inv_key: string = undefined;
  public inv_ord_key: string = undefined;
  public inv_orig_trans_type: string = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'ivd_price':
            case 'ivd_discountamount':
            case 'ivd_total':
            case 'ivd_balance':
            case 'ivd_netpayment':
              var floatKey: 'ivd_price' | 'ivd_discountamount' | 'ivd_total' | 'ivd_balance' | 'ivd_netpayment' = <any>key;
              if (source[floatKey] == null || source[floatKey] == undefined || source[floatKey] == '') {
                this[floatKey] = null;
              } else {
                this[floatKey] = parseFloat(source[floatKey]);
              }
            break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
